import { flow, Instance, SnapshotOut, types } from "mobx-state-tree";
import { RequestApi } from '../../services/api/request-api';
import { withEnvironment } from "../extensions/with-environment";

export const CreateRequestStoreModel = types
    .model("CreateRequestStore")
    .props({
        isRemoteLoading: types.optional(types.boolean,false)
    })
    .extend(withEnvironment)
    .views((_self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars  
    .actions((self) => ({        
        sendRequest: flow(function* (data, callback){
            console.log("ok sending request");
            console.log(JSON.stringify(data));
            const api = new RequestApi(self.environment.api);
            const result = yield api.createRequest(self.environment.clientUserId || 0, data);
            if(result.kind === "ok"){
                console.log("request created");
                callback(true);
            }else{
                console.log(result)
                callback(false);
            }
        })
    }))

type CreateRequestStoreType = Instance<typeof CreateRequestStoreModel>
export interface CreateRequestStore extends CreateRequestStoreType {}
type CreateRequestStoreSnapshotType = SnapshotOut<typeof CreateRequestStoreModel>
export interface CreateRequestStoreSnapshot extends CreateRequestStoreSnapshotType {}
export const createCreateRequestStoreDefaultModel = () => types.optional(CreateRequestStoreModel, {})